module.exports = __webpack_public_path__ + "img/2.9047e4ea.png";